export const itemHeaderTranslate = "cbb";
export default {itemHeaderTranslate};